import { Box, TextField, Typography } from "@mui/material";

interface TextfieldUpdaterProps {
  label: string;
  value: string | undefined;
  setValue: Function;
}

const tfLabelProps = {
  sx: {
    fontFamily: "Manrope",
    color: "#6f7d95",
    fontSize: "1rem !important",
    fontWeight: 600,
    "&.MuiOutlinedInput-notchedOutline": {
      fontSize: "28px",
      border: "0px !important",
    },
  },
};

const tfMainStyle = {
  backgroundColor: "#f4f6f9 !important",
  borderRadius: "5px !important",
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "0px",
  },
};

const tfInputProps = {
  disableUnderline: true,
  sx: {
    fontFamily: "Manrope",
    backgroundColor: "#f4f6f9",
    color: "#6f7d95",
    fontSize: "1rem !important",
    fontWeight: 600,
  },
};

const TextfieldUpdater = ({
  label,
  setValue,
  value,
}: TextfieldUpdaterProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="body1" sx={tfLabelProps.sx}>
        {label}
      </Typography>

      <TextField
        fullWidth
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={tfMainStyle}
        InputLabelProps={tfLabelProps}
        inputProps={tfInputProps}
      />
    </Box>
  );
};

export default TextfieldUpdater;
